<template>

    <div class="row">
        <div class="col-md-6 col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("companies.title.contact-data") }}</h2>
                    <div class="box-tools">
                        <router-link
                            v-if="canEditCompany"
                            class="btn btn-primary btn-xs"
                            :to="{name:'crm.companies.edit', params:{uuid:company.uuid}}"
                            v-tooltip="'Bedrijf bewerken'"
                        >
                            <i class="mdi mdi-pencil"></i>
                        </router-link>

                        <delete-button
                            v-if="canDeleteCompany"
                            :url="route('api.v1.crm.companies.destroy', {uuid:company.uuid})"
                            :name="company.name"
                            v-tooltip="'Bedrijf verwijderen'"
                            title="Bedrijf"
                            classes="btn btn-danger btn-xs"
                            :disabled="!company.candelete"
                        ></delete-button>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-lg-4">{{ Lang.get("global.companyname") }}</th>
                                <td>{{ company.name }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.phone") }}</th>
                                <td>{{ company.phone }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.fax") }}</th>
                                <td>{{ company.fax }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.email") }}</th>
                                <td>{{ company.email }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.url") }}</th>
                                <td>{{ company.url }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("companies.title.address-data") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-lg-4">{{ Lang.get("global.address") }}</th>
                                <td>{{ company.address }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.zipcode") }}</th>
                                <td>{{ company.zipcode }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.city") }}</th>
                                <td>{{ company.city }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.country") }}</th>
                                <td>{{ company.country }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("companies.title.postal-data") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="col-lg-4">{{ Lang.get("global.address") }}</th>
                                <td>{{ company.postal_address }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.zipcode") }}</th>
                                <td>{{ company.postal_zipcode }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.city") }}</th>
                                <td>{{ company.postal_city }}</td>
                            </tr>
                            <tr>
                                <th>{{ Lang.get("global.country") }}</th>
                                <td>{{ company.postal_country }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("companies.title.financial-data") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                        <tr>
                            <th class="col-lg-4">{{ Lang.get("global.bic") }}</th>
                            <td>{{ company.bic }}</td>
                        </tr>
                        <tr>
                            <th>{{ Lang.get("global.iban") }}</th>
                            <td>{{ company.iban }}</td>
                        </tr>
                        <tr>
                            <th>{{ Lang.get("global.vat_number") }}</th>
                            <td>{{ company.vat_number }}</td>
                        </tr>
                        <tr>
                            <th>{{ Lang.get("global.coc_number") }}</th>
                            <td>{{ company.coc_number }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-4">
            <div
                class="box box-solid"
                v-if="can('read','contacts')"
            >
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("companies.show.connectedcontacts") }}</h2>
                    <div class="box-tools" v-if="canUpdateCompany">
                        <connections
                            orig="company"
                            :orig-id="company.uuid"
                            target="contact"
                            :attach-url="route('api.v1.crm.companies.attach', {uuid:company.uuid})"
                            event-on-completed="connectionCompleted"
                            event-on-failed="connectionFailed"
                            @connectionCompleted="contactConnectionCompleted"
                            @connectionFailed="contactConnectionFailed"
                        ></connections>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>{{ Lang.get("global.contact") }}</th>
                                <th>{{ Lang.get("companies.show.function") }}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="company.contacts.length === 0 && company.oldcontacts.length === 0">
                                <td colspan="3">{{ Lang.get("companies.show.noconnectedcontacts") }}</td>
                            </tr>

                            <tr
                                v-for="contact in company.contacts"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'crm.contacts.show', params:{uuid:contact.uuid}}"
                                    >
                                        {{ contact.fullname }}
                                    </router-link>
                                </td>
<!--                                <td>{{ contact.pivot.function }}</td>-->
                                <td>
                                    <company-function
                                        v-if="canUpdateContact"
                                        :current="contact.pivot.function"
                                        :url="route('api.v1.crm.updatefunction', {contact_uuid: contact.uuid, company_uuid: company.uuid})"
                                    ></company-function>
                                    <span v-else>
                                        {{ contact.pivot.function }}
                                    </span>
                                </td>
                                <td class="text-right">
                                    <delete-button
                                        v-if="canUpdateCompany"
                                        :url="route('api.v1.crm.companies.detach', {uuid:company.uuid, target:'contact', target_uuid: contact.uuid})"
                                        title="Koppeling met contactpersoon"
                                        :name="'koppeling met contactpersoon: ' + contact.fullname"
                                        class="btn-xs"
                                        v-tooltip="'Contactpersoon loskoppelen'"
                                        :show-snotify="false"
                                        @delete-completed="contactDetachCompleted"
                                    ></delete-button>
                                </td>
                            </tr>

                            <tr
                                v-for="contact in company.oldcontacts"
                                class="strikethrough"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'crm.contacts.show', params:{uuid:contact.uuid}}"
                                    >
                                        {{ contact.fullname }}
                                    </router-link>
                                </td>
                                <td>{{ contact.pivot.function }}</td>
                                <td class="text-right">
                                    <reconnect
                                        v-if="canUpdateCompany"
                                        :uuid="company.uuid"
                                        target="companies"
                                        :target-uuid="contact.uuid"
                                        type="Contactpersoon"
                                        @reconnectCompleted="reconnectCompleted"
                                        @reconnectFailed="reconnectFailed"
                                    ></reconnect>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div
                class="box box-solid"
                v-if="can('read','projects')"
            >
                <div class="box-header">
                    <h2 class="box-title">Gekoppelde projecten</h2>
                    <div class="box-tools" v-if="canUpdateCompany">
                        <connections
                            orig="company"
                            :orig-id="company.uuid"
                            target="project"
                            :attach-url="route('api.v1.crm.companies.attach', {uuid:company.uuid})"
                            event-on-completed="connectionCompleted"
                            event-on-failed="connectionFailed"
                            @connectionCompleted="projectConnectionCompleted"
                            @connectionFailed="projectConnectionFailed"
                        ></connections>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>{{ Lang.get("global.project") }}</th>
                                <th>{{ Lang.get("global.name") }}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="company.projects.length === 0"><td colspan="3">Er zijn geen gekoppelde projecten beschikbaar</td></tr>
                            <tr
                                v-for="project in company.projects"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'projects.details.index', params:{uuid: project.uuid}}"
                                    >
                                        {{ project.project_name }}
                                    </router-link>
                                </td>
                                <td>{{ project.name }}</td>
                                <td class="text-right">
                                    <delete-button
                                        v-if="canUpdateCompany"
                                        :url="route('api.v1.crm.companies.detach', {uuid:company.uuid, target:'project', target_uuid: project.uuid})"
                                        title="Koppeling met project"
                                        :name="'koppeling met project: ' + project.project_name"
                                        class="btn-xs"
                                        v-tooltip="'Project loskoppelen'"
                                        :show-snotify="false"
                                        @delete-completed="projectDetachCompleted"
                                    ></delete-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("contacts.show.connectedcrmgroups") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Groep</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="company.crmgroups.length === 0"><td colspan="2">Dit bedrijf is niet aan een groep gekoppeld</td></tr>
                            <tr
                                v-for="group in company.crmgroups"
                                :id="'row-' + group.uuid"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'crm.groups.show', params:{uuid:group.uuid}}"
                                    >
                                        {{ group.name }}
                                    </router-link>
                                </td>
                                <td class="text-right">
                                    <delete-button
                                        :parent-element="'row-' + group.uuid"
                                        :url="route('api.v1.crm.groups.detach', {group_uuid:group.uuid, target:'crmgroup', target_uuid:company.uuid})"
                                        title="Gekoppelde groep"
                                        :name="group.name"
                                        class="btn-xs"
                                    ></delete-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("notes.show.header") }}</h2>
                </div>
                <div class="box-body" v-if="company.notes.length === 0">
                    <p>{{ Lang.get("notes.show.nonotes") }}</p>
                </div>
                <div class="box-body no-padding" v-else>
                    <table class="table table-striped">
                        <tbody class="crmNotesList">
                            <tr
                                v-for="note in company.notes"
                                :id="'companynote-' + note.uuid"
                            >
                                <td colspan="3">
                                    <div>
                                        <p>
                                            <strong>Door:</strong>
                                            <strike
                                                v-if="!note.creator.active || note.creator.deleted_at !== null"
                                                v-tooltip="'Deze medewerker werkt hier niet meer'"
                                            >
                                                {{ note.creator.fullname }}
                                            </strike>
                                            <span v-else>{{ note.creator.fullname }}</span>
                                        </p>
                                        <p>
                                            <strong>Datum:</strong>
                                            {{ note.created_at | formatDate }}
                                        </p>
                                        <p><strong>Notitie:</strong></p>
                                        <div v-html="note.note"></div>
                                        <div class="text-right">
                                            <delete-button
                                                v-if="canDeleteNote"
                                                :url="route('api.v1.crm.companies.notes.delete', {uuid:note.uuid})"
                                                :title="Lang.get('notes.show.note')"
                                                :name="Lang.get('notes.show.noteby') + ' ' + note.creator.fullname"
                                                :parent-element="'companynote-' + note.uuid"
                                                v-tooltip="'Notitie verwijderen'"
                                            ></delete-button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <add-note
                v-if="canAddNote"
                :post-url="route('api.v1.crm.companies.notes.add', {company_uuid: company.uuid}, false)"
                :user-name="getAuth.user.fullname"
                @noteAdded="$emit('companyDataChanged')"
            ></add-note>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import AddNote from "../../../components/CRM/AddNote";
import Connections from "../../../components/Common/Connections";
import Reconnect from "../../../components/CRM/Reconnect";
import CompanyFunction from "../../../components/CRM/CompanyFunction";

export default {

    components: {
        AddNote,
        Connections,
        Reconnect,
        CompanyFunction,
    },

    computed: {
        ...mapGetters([
            'can',
            'getAuth',
            'getCompany',
        ]),

        canAddNote() {
            return this.can('write', 'companies');
        },

        canDeleteCompany() {
            return this.can('write', 'companies');
        },

        canDeleteNote() {
            return this.can('write', 'companies');
        },

        canEditCompany() {
            return this.can('write', 'companies');
        },

        canUpdateCompany() {
            return this.can('write', 'companies');
        },

        canUpdateContact() {
            return this.can('write', 'contacts');
        },

        company() {
            return this.getCompany;
        },
    },

    data() {
        return {
            Lang:Lang,
        }
    },

    metaInfo: {
        title:'Company',
    },

    methods: {
        contactConnectionCompleted() {
            this.$emit('companyDataChanged');
            this.$snotify.success('De contact is gekoppeld');
        },
        contactConnectionFailed() {
            this.$snotify.error('Er is een fout opgetreden bij het koppelen van de contact');
        },
        contactDetachCompleted() {
            this.$emit('companyDataChanged');
            this.$snotify.success('De contact is ontkoppeld');
        },
        projectConnectionCompleted() {
            this.$emit('companyDataChanged');
            this.$snotify.success('Het project is gekoppeld');
        },
        projectConnectionFailed() {
            this.$snotify.error('Er is een fout opgetreden bij het koppelen van het project');
        },
        projectDetachCompleted() {
            this.$emit('companyDataChanged');
            this.$snotify.success('Het project is ontkoppeld');
        },
        reconnectCompleted() {
            this.$snotify.success('Opnieuw verbinden is gelukt');
            this.$emit('companyDataChanged');
        },
        reconnectFailed() {
            this.$snotify.error('Er is een fout opgetreden bij het opnieuw verbinden');
        },
    },

    name:'CrmCompaniesShow',

}

</script>
